// Phase 999.4 — option names locked from the admin UI for now.
//
// XOffset and YOffset are reserved pending a follow-up phase that wires a safe
// edit path through the holecapture flow. ZOffset is the one operators do
// need to set from this UI (it's the active outflow correction handled by
// LocationZOffsetHelper.ApplyOutflow), so it stays editable.
//
// We surface XOffset/YOffset in the admin UI (so operators see they exist)
// but disable input and the Edit affordance with a "reserved — future use"
// label.
//
// Match is case-insensitive on the option Name from ref_locationoptiontype.

export const RESERVED_OPTION_NAMES = ['XOffset', 'YOffset'];

export function isReservedOption(name) {
    if (!name) return false;
    const target = String(name).toLowerCase();
    return RESERVED_OPTION_NAMES.some((n) => n.toLowerCase() === target);
}
